import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
// import Alert from "react-bootstrap/Alert";
import "../../styles/open-pages/open-pages.css";
import WelcomeUser from "../../components/Open-pages/user/WelcomeUser";
import HelmetWrapper from "../../HelmetWrapper";
import PMLinkStructure from "../../components/payment-link-system/open-partial-link/PMLinkStructure";
import Notifications from "../../components/push-notifications/Notifications";

const PMLinkOpenPage = () => {
  const navigate = useNavigate();

  // const isNotificationDenied = useSelector(
  //   (state) => state.notification.permission
  // );

  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access");
    }
  }, [pageState]);

  return (
    <HelmetWrapper title="WTF: Pending Partial Payments">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {userInfoData && !isIOS() && <Notifications authData={userInfoData} />}

        <Row>
          <Col>
            <WelcomeUser userName={userInfoData?.name} />
            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </Col>
        </Row>

        <PMLinkStructure
          isCustom={isCustom}
          handleBack={handleBack}
          userInfoData={userInfoData}
        />
      </Container>
    </HelmetWrapper>
  );
};

export default PMLinkOpenPage;
